import React, { useState } from 'react';

import RealEstateMarketGeneralFilters from '../components/realEstateMarketGeneralFilters';
import HomesForSaleCard from '../components/homesForSaleCard';
import SoldHomesCard from '../components/soldHomesCard';

export const MarketSearchOptions = {
    Location: 'location',
    DateWindow: 'dateWindow',
    MaxLotSize: 'maxLotSize',
    MinLotSize: 'minLotSize',
    MaxBldSize: 'maxBldSize',
    MinBldSize: 'minBldSize',
};

const MarketDashboard = () => {
    const [filters, setFilters] = useState({
        [MarketSearchOptions.Location]: 'All Locations',
        [MarketSearchOptions.DateWindow]: 'Last month',
        [MarketSearchOptions.MaxLotSize]: 100000,
        [MarketSearchOptions.MaxBldSize]: 100000,
        [MarketSearchOptions.MinLotSize]: 1000,
        [MarketSearchOptions.MinBldSize]: 1000,
    });

    const handleFiltersChange = (newFilters) =>
        setFilters((current) => ({ ...current, ...newFilters }));

    return (
        <div className="mt-4">
            <RealEstateMarketGeneralFilters
                filters={filters}
                onChange={handleFiltersChange}
            />
            <HomesForSaleCard filters={filters} />
            <SoldHomesCard filters={filters} onChange={handleFiltersChange} />
        </div>
    );
};

export default MarketDashboard;
